// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"52a40a8f","389":"469338f8","488":"411743b6","667":"5a92a404"}[chunkId] + ".chunk.js";
};